export interface RefundEntity {

    id: number | null,
    receiptNo?: string | null,
    refundDraftId?: string | null,
    refundFinalId?: string | null,
    counterCustomerID?: string | null,
    payeeName?: string | null,
    payeeNTN?: string | null,
    paymentAmount?: number | null,
    paiedInvoiceAmount?: number | null,
    totalInvoiceAmount?: number | null,
    handlingCharge?: number | null,
    refundAmount?: number | null,
    chequeCollectorName?: string | null,
    cnic?: string | null,
    mobileNo?: string | null,
    chequeNo?: string | null,
    chequeIssueDate?: Date | null,
    chequeAmount?: number | null,
    createdBy?: string | null,
    createdDate?: Date | null,
    changedBy?: string | null,
    changedDate?: Date | null,
    verifiedBy?: string | null,
    verifiedDate?: Date | null,
    approvedBy?: string | null,
    approvedDate?: Date | null,
    refundedBy?: string | null,
    refundedDatetime?: Date | null,
    processedBy?: string | null,
    processedDate?: Date | null,
    issuedBy?: string | null,
    issuedDate?: Date | null,
    refundType?: string | null,
    status?: string | null,
    remark?: string | null,
    payOrderNo?: string | null,
    bankCode?: string | null,
    agentName?: string | null,

    [key: string]: string | boolean | number | null | Object | undefined
}

export const EMPTY_REFUND_ENTITY: RefundEntity = {
    id: null,
    receiptNo: null,
    refundDraftId: null,
    refundFinalId: null,
    counterCustomerID: null,
    payeeName: null,
    payeeNTN: null,
    paymentAmount: null,
    paiedInvoiceAmount: null,
    totalInvoiceAmount: null,
    handlingCharge: null,
    refundAmount: null,
    chequeCollectorName: null,
    cnic: null,
    mobileNo: null,
    chequeNo: null,
    chequeIssueDate: null,
    chequeAmount: null,
    createdBy: null,
    createdDate: null,
    changedBy: null,
    changedDate: null,
    verifiedBy: null,
    verifiedDate: null,
    approvedBy: null,
    approvedDate: null,
    refundedBy: null,
    refundedDatetime: null,
    processedBy: null,
    processedDate: null,
    issuedBy: null,
    issuedDate: null,
    refundType: null,
    status: null,
    remark: null,
    payOrderNo: null,
    bankCode: null,
    agentName: null,
}
